import React from 'react'
import { Link } from 'react-router-dom'
import { ExternalLinks } from '../ExternalLinks'

// blog 頁共用站頭：沿用首頁上方的 logo 圖片與外部連結列。
// 注意 blog 路由不在根目錄，資源路徑要用絕對路徑（/logo.png）。
export function BlogChrome({ children }: { children: React.ReactNode }) {
  return (
    <div className="container p-0">
      <Link to="/">
        <img
          className="img-fluid d-block mt-3 border mx-auto"
          src="/logo.png"
          alt="logo"
        />
      </Link>
      <ExternalLinks />
      {children}
    </div>
  )
}
